class ButtonBaseStateTrailingSlotIconController {
  constructor(host) {
    this.host = host;
  }
  handleFixedTrailingSlotIcon(stateValue) {
    if (!stateValue) {
      return;
    }
    const fixedTrailingSlottedElements = this.host.querySelectorAll?.('[slot="fixed-trailing"]') ?? [];
    if (fixedTrailingSlottedElements.length > 0) {
      fixedTrailingSlottedElements.forEach((element) => this.host.removeChild(element));
    }
    switch (stateValue) {
      case "processing":
        this.#appendFixedTrailingSlotIcon({ animation: "spin", icon: "spinner-third" });
        break;
      case "success":
        this.#appendFixedTrailingSlotIcon({ icon: "check" });
        break;
    }
  }
  #appendFixedTrailingSlotIcon({ animation, icon }) {
    const $icon = document.createElement("crnt-icon");
    $icon.setAttribute("slot", "fixed-trailing");
    $icon.setAttribute("icon", icon);
    if (animation) {
      $icon.setAttribute("animation", animation);
    }
    this.host.appendChild($icon);
  }
}

export { ButtonBaseStateTrailingSlotIconController };
